import { Button, Col, Form, Input, Row, Select, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { ReactComponent as DownloadIcon } from "../../../../../assets/icon/下载.svg";

import PartIStyle from "./partI.module.css";
import selectoneOptions from "../../json/MuationOneSelect";
import styled from "styled-components";
import http from "../../../../../utils/http";

// 使用 styled-components 定义样式
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;
function PartI() {
  const [form] = Form.useForm();
  const [Pages, setPages] = useState(1);
  const [pageSize, setpageSize] = useState(10);
  const [total, setTotal] = useState();
  const [formVal, setFormval] = useState({});
  const [data, setData] = useState([]);
const [helpVal,setHelpVal]=useState("")
const [IsSubmitLoading,setSubmitLoading]=useState(false)

  const onFinish = (value) => {
    setFormval(value);
    setSubmitLoading(true)
    getTableData(value, Pages, pageSize);
  };
  useEffect(() => {
    getTableData(formVal, Pages, pageSize);
  }, [Pages, pageSize]);
  const getTableData = (value, pages, page_size) => {
    if(value.variation_type=='gene_id'){
        http
        .get(
          `/api/population/variation/?page=${pages}&pageSize=${page_size}&gene_body=${
            value.variety || ""
          }&gene_id=${value.gene || "Chr01.g00051"}`
        )
        .then((res) => {
          setTotal(res.count);
          setData(res.results);
          setSubmitLoading(false)
        })
        .catch((err) => {
          setSubmitLoading(false)

        });
    }else if(value.variation_type=='gene_region'){
        http
        .get(
          `/api/population/variation/?page=${pages}&pageSize=${page_size}&gene_body=${
            value.variety || ""
          }&gene_region=${value.gene || "Chr01:100000-200000"}`
        )
        .then((res) => {
          setSubmitLoading(false)
          setTotal(res.count);
          setData(res.results);
        })
        .catch((err) => {
          setSubmitLoading(false)

        });
    }
   
  };
  // 分页配置
  const paginationConfig = {
    current: Pages,
    pageSize: pageSize,
    total: total,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    onChange: (page) => {
      setPages(page);
    },
    onShowSizeChange: (current, size) => {
      setpageSize(size);
      setPages(1); // Reset to first page on page size change
    },
  };
  const colums = [
    {
      align: "center",
      key: "1",
      title: "Gene body",
      dataIndex: "gene_body",
    },
    {
      align: "center",
      key: "2",
      title: "Gene Info",
      dataIndex: "gene_info",
    },
    {
      align: "center",
      key: "3",
      title: "CHR",
      dataIndex: "chr",
    },
    {
      align: "center",
      key: "4",
      title: "POS",
      dataIndex: "pos",
    },
    {
      align: "center",
      key: "5",
      title: "REF",
      dataIndex: "ref",
    },
    {
      align: "center",
      key: "6",
      title: "ALT",
      dataIndex: "alt",
    },
  ];
  const [geneidVal,setGeneIdVal]=useState("Chr01.g00051")
  
function convertToCSV(jsonData) {
  if (!jsonData || jsonData.length === 0) {
    return "";
  }

  const columns = Object.keys(jsonData[0]);
  let csvString = columns.join(",") + "\n";

  jsonData.forEach((row) => {
    let rowString = columns.map((column) => {
      let value = row[column];
      if (typeof value === "string" && (value.includes(",") || value.includes("\n") || value.includes('"'))) {
        value = `"${value.replace(/"/g, '""')}"`; // 替换双引号为两个双引号
      }
      return value;
    }).join(",");
    csvString += rowString + "\n";
  });

  return csvString;
}

// 文件下载函数
function downloadCSV(csvString, filename) {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "data.csv"; // 设置文件名
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
const handleDownloadCSV = () => {
  if (data.length === 0) {
    alert("No data to download");
    return;
  }

  // 从表单中获取 Genome 的值
  const genomeValue = form.getFieldValue("gene");

  // 如果 Genome 值为空，使用默认文件名
  const filename = genomeValue ? `${genomeValue}.csv` : "Chr01.g00051.csv";

  // 将表格数据转换为 CSV 字符串
  const csvString = convertToCSV(data);

  // 触发文件下载
  downloadCSV(csvString, filename);
};
  return (
    <div>
      <div className={PartIStyle.MutationInform_FormDiv}>
        <Form
          style={{ width: "95%", margin: "10px auto" }}
          onFinish={onFinish}
          form={form}
          initialValues={{
            variety: ["exonic", "intronic"],
            variation_type:"gene_id"
          }}
        >
          <Row>
            <Col span={5}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Method</span>}
                name="variation_type"
              >
                <Select
                  style={{ width: 200 }}
                  onChange={(e)=>{
                        if(e=='gene_region'){
                           
                            setGeneIdVal('Chr01:100000-200000')
                        }else if(e=='gene_id'){
                            
                      setGeneIdVal('Chr01.g00051')

                        }
                  }}
                  options={[
                    {
                      key: "1",
                      label: "Gene ID",
                      value: "gene_id",
                    },
                    {
                      key: "2",
                      label: "Gene Region",
                      value: "gene_region",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="gene"
              
              >
                <Input placeholder={geneidVal} style={{ width: 250 }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Gene body</span>}
                name="variety"
              >
                <Select
                  style={{ width: 300 }}
                  mode="multiple"
                  options={selectoneOptions}
                  maxTagCount={2}
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      overlayStyle={{
                        pointerEvents: "none",
                      }}
                      title={omittedValues.map(({ label }) => label).join(", ")}
                    >
                      <span>Hover Me</span>
                    </Tooltip>
                  )}
                />
              </Form.Item>
            </Col>
          </Row>

         
          <Form.Item
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              style={{
                margin: "0 100px",
                width: "150px",
                background: "#076A09",
                border: "none",
                color: "white",
              }}
              htmlType="submit"
              loading={IsSubmitLoading}
            >
              Search
            </Button>
            <Button style={{ margin: "0 100px", width: "150px" }}
            onClick={()=>{
                form.resetFields()
                setData([])
            }}
            >Reset</Button>
          </Form.Item>
        </Form>
      </div>
      <div className={PartIStyle.MutationInform_TableDiv}>
        <div className={PartIStyle.MutationInform_Table_Download}>
          <Button
            style={{
              display: "flex",
              alignItems: "center",
              border: "none",
              margin: "0 10px",
            }}
            onClick={handleDownloadCSV}
          >
            <DownloadIcon width={20} />{" "}
            <span
              style={{
                margin: "0 10px",
                fontFamily: "SourceHanSansSC-regular",
              }}
            >
              CSV
            </span>
          </Button>
        
        </div>
        <StyledTable
          style={{ width: "100%", margin: "10px auto" }}
          bordered
          columns={colums}
          dataSource={data}
          pagination={paginationConfig}
        />
      </div>
    </div>
  );
}

export default PartI;
